import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid'
import Notification from '../../components/Notification/Notification';
import './styles.css';
import api from '../../services/api';
const sleep = (ms) => new Promise(res => setTimeout(res,ms));
const useStyles = makeStyles((theme) => ({
	root: {
		height: '100vh'
	},
	image: {
		backgroundImage: 'url(https://www.canaadoscarajas.pa.gov.br/novo/wp-content/uploads/2019/08/LETREIRO-TURISTICO.jpeg)',
		backgroundRepeat: 'no-repeat',
		backgroundColor:
			theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	paper: {
		margin: theme.spacing(8, 4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));



export default function ChoiceNewPassword(props) {
	const classes = useStyles();
	const navigate = useNavigate()
	const [password, setPassword] = useState("");
	const [resetCode, setResetCode] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [notify, setNotify] = useState({
		isOpen: false,
		message: '',
		type: '',
		title: '',
	});

	const location = useLocation();
	// const navigate = useNavigate();

	useEffect(() => {
		if (!!location.state.email) {
			setNotify({
				isOpen: true,
				title: 'E-mail de recuperação enviado com sucesso!',
				message: 'Um email com os dados de recuperação foi enviado, caso não encontre verifique a caixa de spam.',
				type: 'success',
			});
		}

	}, [location.state.email]);


	function checkPasswordsMatch() {
		if (password !== confirmPassword) {
			setNotify({
				isOpen: true,
				title: 'As senhas não coincidem',
				message: 'Por favor, digite novamente a senha.',
				type: 'error',
			});

			return false;
		}

		return true;
	}

	async function handleSubmit(e) {
		e.preventDefault();

		//Verifica se as senhas coincidem
		if (checkPasswordsMatch() && location.state.email) {

			//Faz a requisição
			api.post('/password/update', {
				"email": location.state.email,
				"code": resetCode,
				"password": password
			})
			.then(async d =>{
				setNotify({
					isOpen: true,
					title: 'E-mail de recuperação enviado com sucesso!',
					message: 'Um email com os dados de recuperação foi enviado, caso não encontre verifique a caixa de spam.',
					type: 'success',
				});
				await sleep(2000)
				//Dentro do then da requisiçao
				navigate('/');
			})
			.catch(e => {
				setNotify({
					isOpen: true,
					title: 'Error',
					message: e.response?.data?.error?.message || 'Algo deu errado, não foi possível concluir sua solicitação.',
					type: 'error',
				});
			});
		}





	}

	return (
		<Grid container component="main" className={classes.root}>
			<CssBaseline />
			<Grid item xs={false} sm={4} md={7} className={classes.image} />
			<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
				<div className="new-password-container">

					<Grid container alignItems="center">
						<CssBaseline />

						<div className={classes.paper}>
							<Avatar className={classes.avatar}>
								<LockOutlinedIcon />
							</Avatar>

							<Typography component="h1" variant="h5">
								Alterar Senha
							</Typography>

							<form className={classes.form} onSubmit={handleSubmit}>
								<TextField
									variant="outlined"
									margin="normal"
									required
									fullWidth
									type='text'
									label="Código de reset"
									autoFocus
									value={resetCode}
									onChange={e => setResetCode(e.target.value)}
								/>
								<TextField
									variant="outlined"
									margin="normal"
									required
									fullWidth
									type='password'
									label="Nova senha"
									autoFocus
									value={password}
									onChange={e => setPassword(e.target.value)}
								/>

								<TextField
									variant="outlined"
									margin="normal"
									required
									type='password'
									error={password !== confirmPassword}
									fullWidth
									label="Confirme a nova senha"
									autoFocus
									value={confirmPassword}
									onChange={e => setConfirmPassword(e.target.value)}
								/>

								<div className="logar">
									<button type="submit" className="button">Alterar Senha</button >
								</div>

								<Grid
									container
									alignItems='center'
									justifyContent='center'
								>
									<Grid item>
										<Link style={{ cursor: 'pointer' }} href='/'>
											Voltar a tela de Login
										</Link>
									</Grid>
								</Grid>

								<Grid container>
									<Grid item style={{ 'textAlign': 'left', 'marginTop': '10px' }}>
										<p>Problemas para realizar login? Entre em contato com o administrador
											do sistema através do e-mail <b>projetocanaaufpa@gmail.com</b>.</p>
									</Grid>
								</Grid>

							</form>
						</div>
					</Grid>
				</div>
			</Grid>


			<Notification notify={notify} setNotify={setNotify} />
		</Grid>
	);
}